import { gql } from "apollo-angular";

export const EMAIL_LOGIN = gql`
  mutation EmailLogin($email: String!, $password: String!) {
    emailLogin(email: $email, password: $password) {
      accessToken
      username
      mobile
      email
      status
      refreshToken
      expired
      type
      roleName
      roleId
      userId
      district
      sessionStart
      idleTimeout
    }
  }
`;
export const MOBILE_OTP_LOGIN = gql`
  mutation MobileOtpLogin($mobile: String!) {
    mobileOtpLogin(mobile: $mobile) {
      accessToken
      username
      mobile
      email
      status
      refreshToken
      expired
      type
      roleName
      roleId
      userId
      district
      sessionStart
      idleTimeout
    }
  }
`;

export const MOBILE_LOGIN = gql`
  mutation MobileLogin($mobile: String!, $password: String!) {
    mobileLogin(mobile: $mobile, password: $password) {
      accessToken
      username
      mobile
      email
      status
      refreshToken
      expired
      type
      roleName
      roleId
      userId
      district
      sessionStart
      idleTimeout
    }
  }
`;
export const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      accessToken
      username
      mobile
      email
      status
      refreshToken
      expired
      type
      roleName
      roleId
      userId
      district
      sessionStart
      idleTimeout
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      username
      mobile
      email
      status
      refreshToken
      expired
      type
      roleName
      roleId
      userId
      district
      sessionStart
      idleTimeout
    }
  }
`;
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $mobile: String!
    $oldPassword: String!
    $newPassword: String!
  ) {
    changePassword(
      mobile: $mobile
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      username
      email
      mobile
      status
      type
      version
    }
  }
`;
export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($mobile: String!, $username: String!) {
    forgotPassword(mobile: $mobile, username: $username) {
      username
      mobile
      displayName
      type
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation ResetPassword($mobile: String!, $newPassword: String!, $username: String) {
    resetPassword(mobile: $mobile, newPassword: $newPassword, username: $username)
  }
`;

export const LOGOUT = gql`
  mutation Logout($refreshToken: String) {
    logout(refreshToken: $refreshToken)
  }
`;
